// @flow
import React from 'react';
import './style.less';

type TProps = {
    children: any,
    className?: string,
    round?: boolean,
    theme?: 'gray' | 'blue' | 'green' | 'yellow' | 'red',
};

function ItemBack({children, className, round, theme = 'gray'}: TProps) {
    let fullClassName = `item-back item-back_${theme}`;

    if (round) {
        fullClassName += ' item-back_round';
    }

    if (className) {
        fullClassName += ` ${className}`;
    }

    return <div className={fullClassName}>{children}</div>;
}

export {ItemBack};
